export default [
  { name: 'Busan', code: 'KR-26' },
  { name: 'Chungbuk', code: 'KR-43' },
  { name: 'Chungnam', code: 'KR-44' },
  { name: 'Daegu', code: 'KR-27' },
  { name: 'Daejeon', code: 'KR-30' },
  { name: 'Gangwon', code: 'KR-42' },
  { name: 'Gwangju', code: 'KR-29' },
  { name: 'Gyeongbuk', code: 'KR-47' },
  { name: 'Gyeonggi', code: 'KR-41' },
  { name: 'Gyeongnam', code: 'KR-48' },
  { name: 'Incheon', code: 'KR-28' },
  { name: 'Jeju', code: 'KR-49' },
  { name: 'Jeonbuk', code: 'KR-45' },
  { name: 'Jeonnam', code: 'KR-46' },
  { name: 'Sejong', code: 'KR-50' },
  { name: 'Seoul', code: 'KR-11' },
  { name: 'Ulsan', code: 'KR-31' }
];
